<div class="flex min-h-dvh flex-col overflow-y-auto py-12 sm:px-6 lg:px-8">
  <main class="mx-auto w-full max-w-2xl px-6 pt-10 lg:px-8">
    <img
      class="mx-auto h-10 w-auto sm:h-12 dark:hidden"
      src="../assets/logos/official/SHOUT_studio_logo_full_colour_black.svg"
      alt="SHOUT Studio"
    />
    <img
      class="mx-auto hidden h-10 w-auto sm:h-12 dark:block"
      src="../assets/logos/official/SHOUT_studio_logo_full_colour_white.svg"
      alt="SHOUT Studio"
    />

    <p class="mt-10 text-center text-sm font-semibold text-primary/80">Account blocked</p>

    <h1
      class="mt-4 text-balance text-center text-3xl font-semibold tracking-tight text-heading sm:text-4xl"
    >
      Your account has been blocked from SHOUT
    </h1>

    <p class="mt-6 text-pretty text-center text-base text-body">
      Access to this platform has been removed for your account. If you believe this is a mistake,
      please contact our support team.
    </p>

    <div class="mt-10 flex flex-col items-center gap-4 sm:flex-row sm:justify-center">
      <a
        routerLink="/login"
        class="text-sm font-semibold text-accent hover:text-primary/85 dark:hover:text-primary/85"
      >
        <span aria-hidden="true">&larr;</span> Back to login
      </a>
      <a
        href="https://shoutugc.com/book-demo"
        class="text-sm font-semibold text-accent hover:text-primary/85 dark:hover:text-primary/85"
      >
        Contact support
      </a>
    </div>
  </main>
</div>
